import { shallowEqual, useSelector } from 'react-redux';
import MediaService from '../../../services/MediaService';
import './PhotoTimePreview.scss';

// The HTML code for the camera. This opens the camera, shows the correct prompt,
// and uploads the photo once it&apos;s taken.
const PhotoTimePreview = ({ dataUri, onConfirmPreview, onCancelPreview }) => {
  // Initialize variables to be used later
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  const confirmIcon = MediaService.getImage(
    '/Module1Images/check_button_small.png',
    login
  );
  const cancelIcon = MediaService.getImage(
    '/Module1Images/x_button.png',
    login
  );

  return (
    <div className='phototime-preview'>
      <figure>
        <img src={dataUri} alt='uri' />
      </figure>
      <div className='preview-action'>
        <button onClick={() => onCancelPreview()}>
          <img src={cancelIcon} alt='cancel' />
        </button>

        <button onClick={() => onConfirmPreview()}>
          <img src={confirmIcon} alt='confirm' />
        </button>
      </div>
    </div>
  );
};

export default PhotoTimePreview;
